<template>
  <div
    v-if="visible"
    class="items-images-thumbnail"
    :style="{ 'background-image': `url(${imgSrc})` }"
    v-on="$listeners"
  >
    <div
      v-if="item.isFolder"
      class="item-category-name-layer"
    >
      <router-link :to="`/referenciak/${item.id}`">
        {{ item.name }}
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReferenceItem',
  props: {
    item: {
      type: Object,
      required: true,
    },
    gApiKey: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      imgSrc: null,
      visible: true,
    };
  },
  async created() {
    try {
      if (!this.item.isFolder) {
        this.imgSrc = `https://www.googleapis.com/drive/v3/files/${this.item.id}?alt=media&key=${this.gApiKey}`;

        return;
      }

      const response = await fetch(`https://www.googleapis.com/drive/v3/files/?q='${this.item.id}'+in+parents&mimeType='image/jpeg'&key=${this.gApiKey}`);
      const data = await response.json();
      const image = data.files[0];

      if (image) {
        this.imgSrc = `https://www.googleapis.com/drive/v3/files/${image.id}?alt=media&key=${this.gApiKey}`;
      } else {
        this.visible = false;
      }
    } catch (error) {
      this.$emit('error', error);
    }
  },
};
</script>

<style scoped>
  .items-images-thumbnail {
    position: relative;
    margin: 5px;
    background-repeat: no-repeat;
    background-position: 50% 50%;
    background-size: cover;
    width: 300px;
    height: 300px;
    cursor: pointer;
  }

  img {
    width: 100%;
  }

  @media (max-width: 1100px) {
    .items-images-thumbnail {
      width: 100%;
      max-width: 512px;
      margin: 0;
    }
  }

  .item-category-name-layer {
    position: absolute !important;
    margin: 0 !important;
    height: 100%;
    width: 101%;
    background: rgba(255, 255, 255, 0.7);
    display: table;
  }

  .item-category-name-layer:hover {
    opacity: 0;
  }

  .item-category-name-layer a {
    width: 100%;
    word-spacing: 100vw;
    margin: 0;
    text-align: center;
    font-weight: 600;
    color: #eb2e4a !important;
    line-height: 1.2;
    display: table-cell;
    vertical-align: middle;
    text-decoration: none;
    font-size: 24px;
  }
</style>



// WEBPACK FOOTER //
// ReferenceItem.vue?a272e570